import { validate } from 'isemail';

/*
 * From the library documentation: The minDomainAtoms option is an optional positive integer
 * that specifies the minimum number of domain atoms that must be included for the email address
 * to be considered valid. Be careful with the option, as some top-level domains, like io,
 * directly support email addresses.
 *
 * We chose to be more strict and accept this risk as JPMorgan requires a 2 part domain for
 * their recipients, and single level domain emails are uncommon. If anything comes up in
 * support from a partner, we can provide this reasoning as a response.
 */

export const isEmail = (email?: string): boolean =>
  (email && validate(email, { minDomainAtoms: 2 })) || false;
